import React from "react";
import { motion } from "framer-motion";
import Logo from "../assets/logo.png";

const LoadingFallback = () => {
  // Animation variants for the snake circles
  const circleVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 2,
        ease: "linear",
        repeat: Infinity,
      },
    },
  };

  // Scale animation for the icon
  const iconVariants = {
    animate: {
      scale: [0.8, 1, 0.8],
      transition: {
        duration: 1.5,
        ease: "easeInOut",
        repeat: Infinity,
      },
    },
  };

  return (
    <div className="fixed inset-0 bg-white bg-opacity-90 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="relative w-24 h-24 flex items-center justify-center">
        {/* Rotating circles */}
        {[...Array(3)].map((_, index) => (
          <motion.div
            key={index}
            className={`absolute w-full h-full border-2 border-blue-500 rounded-full border-t-transparent border-l-transparent`}
            variants={circleVariants}
            animate="animate"
            style={{
              animationDelay: `${index * 0.2}s`,
              opacity: 1 - index * 0.2,
              scale: 1 - index * 0.1,
            }}
          />
        ))}

        {/* Center icon with pulse animation */}
        <motion.div
          className="relative z-10"
          variants={iconVariants}
          animate="animate"
        >
          <img src={Logo} alt="Logo" className="h-full object-contain" />
        </motion.div>
      </div>
    </div>
  );
};

export default LoadingFallback;
